module.exports = __webpack_public_path__ + "static/anli1.18bc448c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/anli1.jpg
// module id = 714
// module chunks = 168707334958949